module.exports = __webpack_public_path__ + "static/media/Email.072e562b.svg";